import {inject, Injectable} from '@angular/core';
import {firstValueFrom} from 'rxjs';
import {HttpClient} from '@angular/common/http';
import {ListadoAEAT, Recibo, Sepa} from '@kilobytelab/types';
import {API_URL_TOKEN} from '../token';

@Injectable({
  providedIn: 'root'
})
export class ApiRecibosService {

  private http = inject(HttpClient);
  private apiUrl = inject(API_URL_TOKEN);

  /*** recibos ***/

  getDatosSepa(): Promise<Sepa> {
    const url = `${this.apiUrl}recibos/sepa`;
    return firstValueFrom(this.http.get<Sepa>(url))
  }
  getRecibos(mes: number, year: number): Promise<Recibo[]> {
    const url = `${this.apiUrl}recibos/${mes}/${year}`;
    return firstValueFrom(this.http.get<Recibo[]>(url))
  }
  getRecibosPosibles(mes: number, year: number): Promise<Recibo[]> {
    const url = `${this.apiUrl}recibos/posibles/${mes}/${year}`;
    return firstValueFrom(this.http.get<Recibo[]>(url))
  }
  getRecibosAlumno(id: number): Promise<Recibo[]> {
    const url = `${this.apiUrl}recibos/alumno/${id}`;
    return firstValueFrom(this.http.get<Recibo[]>(url))
  }
  getRecibosYear(year: number): Promise<Recibo[]> {
    const url = `${this.apiUrl}recibos/year/${year}`;
    return firstValueFrom(this.http.get<Recibo[]>(url))
  }
  getRecibosAlumnoYear(id: number, year: number): Promise<Recibo[]> {
    const url = `${this.apiUrl}recibos/alumno/${id}/${year}`;
    return firstValueFrom(this.http.get<Recibo[]>(url))
  }
  saveRecibos(mes: number, year: number, data: Recibo[]): Promise<any> {
    const url = `${this.apiUrl}recibos/masivo/${mes}/${year}`;
    return firstValueFrom(this.http.post<any>(url, {recibos: data}))
  }
  printRecibos(recibos: Recibo[]): Promise<any> {
    const url = `${this.apiUrl}recibos/print`;
    return firstValueFrom(this.http.post<any>(url, {recibos: recibos}))
  }
  printTotalAnual(datos: {year: number, listado: {nombre: string, recibos: Recibo[],
      suma: number}[], meses: string[], total: any}): Promise<string> {
    const url = `${this.apiUrl}recibos/print/anual`;
    return firstValueFrom(this.http.post<string>(url, datos))
  }
  printAEAT(datos: {year: number, listado: ListadoAEAT[]}): Promise<string> {
    const url = `${this.apiUrl}recibos/print/aeat`;
    return firstValueFrom(this.http.post<string>(url, datos))
  }
  updateSEPA(datos: Sepa): Promise<any> {
    const url = `${this.apiUrl}recibos/sepa`;
    return firstValueFrom(this.http.post<any>(url, datos))
  }
  remesaXML(data: {fecha: string, recibos: Recibo[]}): Promise<string> {
    const url = `${this.apiUrl}recibos/remesaXML`;
    return firstValueFrom(this.http.post<string>(url, data, {responseType: 'text' as 'json'}))
  }
  updateRecibo(datos: {id: number, mes: number|string, year: number|string, campo: string, valor: string|number}): Promise<any> {
    const url = `${this.apiUrl}recibos`;
    return firstValueFrom(this.http.put<any>(url, datos))
  }
  eliminarRecibo(data: Recibo): Promise<any> {
    const url = `${this.apiUrl}recibos/${data.id}/${data.mes}/${data.year}`;
    return firstValueFrom(this.http.delete<any>(url))
  }

}
